var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.iconClass,attrs:{"className":"svg-icon","aria-hidden":"true"}},[_c('use',{style:({ fill: _vm.hoverColor }),attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }